import { assertBackendApiAllowed } from '../config/backendApiSecurity';
import { KEYWORDYAB_BACKEND_URL } from '../config/backendUrl';

export function buildBackendApiUrl(apiPath: string): string {
  const normalized =
    apiPath.startsWith('/') ? apiPath : `/${apiPath}`;
  return `${KEYWORDYAB_BACKEND_URL}${normalized}`;
}

export async function backendFetch(
  apiPath: string,
  init?: RequestInit,
): Promise<Response> {
  assertBackendApiAllowed(apiPath);
  return fetch(buildBackendApiUrl(apiPath), init);
}
